<template>
  <div class="empty_wrap" :style="'height:' + h">
    <img v-if="!whiteBg" src="~@/assets/images/common/empty_tips.png" alt="">
    <img v-if="whiteBg" src="~@/assets/images/common/no_curri.png" alt="">
    <p>{{tips||$t('noData')}} <span class="addbtn" @click="$emit('callback')">{{ name }}</span> </p>
  </div>
</template>

<script>

export default {
  props: {
    tips: {
      type: String
    },
    name: {
      type: String
    },
    h: {
      type: String
    },
    whiteBg: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .empty_wrap
    height 100%
    width 100%
    display flex
    justify-content center
    align-items center
    flex-direction column
    img
      margin-top -.2rem
    p
      margin-top .2rem
    .addbtn
      color #4cd964
      font-style italic
      cursor pointer
      font-weight bold
</style>
